export default "__VITE_ASSET__7d59b385__"